import React, { useEffect } from "react";
import { ListGroup } from "react-bootstrap";
import "./ListItemView.scss";
import DetailsView from "./DetailsView";
import { ListItemProps } from "types/ListAndDetailTypes";
import DetailHeader from "./DetailHeader";
import { ActiveComponentEnum } from "enums/enums";
import useApi from "hooks/useApi";
import WithApi from "components/ui/WithApi/WithApi";

const ListItem: React.FC<ListItemProps> = ({ onNavigate, complaint, fetchDetails, isShowDetails, navigateTo = ActiveComponentEnum.List, isShowLogo = true, isFullSubHeader = false, isShowTextInIcon = true, sumComplaints = 0, isComparedOnYear = false }) => {
  const { callApi, data: listView, loading, error } = useApi(fetchDetails);

  useEffect(() => {
    callApi(complaint.id)
  }, [complaint.id]);

  return (
    <div>
      <DetailHeader onNavigate={onNavigate} navigateTo={navigateTo} complaint={complaint} sumComplaints={sumComplaints} isShowDetails={isShowDetails} isShowLogo={isShowLogo} isFullSubHeader={isFullSubHeader} isShowTextInIcon={isShowTextInIcon}/>
      <WithApi data={listView} loading={loading} error={error}><ListGroup className="pt-3 ">
        {listView && listView.map((item, index) => (
          <ListGroup.Item key={index} className="border-0 grey-li-border-bottom">
            <DetailsView dataList={item} isComparedOnYear={isComparedOnYear}/>
          </ListGroup.Item>
        ))}
      </ListGroup>
      </WithApi>
    </div>
  );
};

export default ListItem;
